import React from 'react'
import Layout from './Layout'
import SubmittedForms from '../../components/User/DynamicForms/SubmittedForms'

export const SubmittedFormPage = () => <Layout><SubmittedForms /></Layout>